import React from "react";
import { Card, Tag, Typography, Avatar, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { UserOutlined, EyeOutlined } from "@ant-design/icons";

const { Meta } = Card;
const { Text } = Typography;

export function TherapyCardInst({ therapy, onClick }) {
  const { t } = useTranslation("institution");

  // OJO: `title` y las categorias los escribe el terapeuta y viven en BD. Son
  // contenido clinico suyo, no interfaz: aqui no se traducen.
  const { title, image, author, categories, active } = therapy;

  return (
    <Card
      hoverable
      cover={
        <div style={{ height: 160, overflow: "hidden", position: "relative" }}>
          <img
            alt={title}
            src={image}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <div style={{ position: "absolute", top: 10, right: 10 }}>
            <Tag color={active ? "success" : "default"}>
              {active ? t("therapies.card.active") : t("therapies.card.archived")}
            </Tag>
          </div>
        </div>
      }
      actions={[
        <Tooltip title={t("therapies.card.viewContent")}>
          <EyeOutlined key="view" onClick={() => onClick(therapy)} />
        </Tooltip>,
      ]}
      style={{ borderRadius: 12, overflow: "hidden" }}
    >
      <Meta
        title={title}
        description={
          <div style={{ marginTop: 8 }}>
            <div
              style={{
                marginBottom: 8,
                display: "flex",
                gap: 4,
                flexWrap: "wrap",
              }}
            >
              {categories.slice(0, 2).map((cat) => (
                <Tag
                  key={cat._id}
                  color={cat.colorCode}
                  style={{ margin: 0, fontSize: 10 }}
                >
                  {cat.title}
                </Tag>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                marginTop: 12,
              }}
            >
              <Avatar
                src={author?.avatar}
                icon={<UserOutlined />}
                size="small"
              />
              <Text type="secondary" style={{ fontSize: 12 }}>
                {author
                  ? `${author.firstname} ${author.lastname}`
                  : t("therapies.card.noAuthor")}
              </Text>
            </div>
          </div>
        }
      />
    </Card>
  );
}
